import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { CONTACT_KIND_LABELS, type DuplicateGroup } from '@kontor/shared';
import { api } from '../../api';
import { useSession } from '../../session';
import './contacts.css';

/** Alle Gruppen von Kontakten mit gleicher E-Mail-Adresse oder Telefonnummer (KON-049), mit Weg zum Zusammenführen */
export function DuplicatesPage() {
  const { can } = useSession();
  const groups = useQuery({ queryKey: ['contact-duplicate-groups'], queryFn: async () => (await api<{ data: DuplicateGroup[] }>('GET', '/contacts/duplicates')).data });

  return (
    <>
      <p><Link to="/kontakte" className="back-link">← Alle Kontakte</Link></p>
      <div className="page-head">
        <h1>Mögliche Dubletten</h1>
        <span className="muted">{groups.data ? `${groups.data.length} Gruppen` : ''}</span>
      </div>
      <p className="muted">Kontakte mit gleicher E-Mail-Adresse oder Telefonnummer. Nicht jede Gruppe ist eine Dublette: Manchmal teilen sich zwei Personen eine Nummer. Zusammengeführt wird nur, was Sie ausdrücklich wählen.</p>

      {groups.isLoading && <p className="muted">Wird geladen …</p>}
      {groups.isError && <div className="alert alert--error">{(groups.error as Error).message}</div>}
      {groups.data?.length === 0 && <div className="card"><p className="muted">Keine Dubletten gefunden.</p></div>}

      {groups.data?.map((g) => {
        const [first, ...rest] = g.contacts;
        const why = g.reasons.map((r) => (r === 'email' ? 'gleiche E-Mail-Adresse' : 'gleiche Telefonnummer')).join(' und ');
        return (
          <section key={g.contacts.map((c) => c.id).join()} className="card duplicate-group">
            <p className="muted small">{why}</p>
            <ul className="contact-options">
              {g.contacts.map((c) => (
                <li key={c.id}>
                  <span className="contact-options__who">
                    <Link to={`/kontakte/${c.id}`} className="strong-link">{c.name}</Link>
                    <span className="badge">{CONTACT_KIND_LABELS[c.kind]}</span>
                    <div className="muted small">{[c.email, c.phone, [c.postalCode, c.city].filter(Boolean).join(' ')].filter(Boolean).join(' · ')}</div>
                  </span>
                  {can('contacts.write') && c.id !== first!.id && c.kind === first!.kind && (
                    <Link className="btn btn--secondary btn--sm" to={`/kontakte/${first!.id}/zusammenfuehren?mit=${c.id}`}>Mit {first!.name} zusammenführen</Link>
                  )}
                </li>
              ))}
            </ul>
            {rest.length > 0 && rest.some((c) => c.kind !== first!.kind) && <p className="muted small">Eine Person und eine Firma lassen sich nicht zusammenführen.</p>}
          </section>
        );
      })}
    </>
  );
}
